import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconRoom = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconRoom",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-107q-14 0-28-5t-25-15q-65-60-115-117t-83-110-51-103-18-95q0-150 97-239t223-89 224 89 96 239q0 45-17 95t-51 103-84 110-115 117q-11 10-25 15t-28 5m0-373q33 0 57-23t23-57-23-56-57-24-56 24-24 56 24 57 56 23"
  })
}));
IconRoom.displayName = 'IconRoom';